export default __webpack_public_path__ + "images/3f0157fb14a7e04ab984ca044a3b4f63.svg";